import { Command } from "ckeditor5";
import { PLACEHOLDER_CHIP_MODEL } from "src/components/CKEditor5/PlaceholderChip/placeholderChipModel.ts";

/**
 * Вставляет плейсхолдер сразу предметом, а не текстом.
 *
 * Кнопки над редактором вставляли строку `{{ contact.NACHNAME }}` символами, и
 * человек видел ровно то, от чего чипы должны были избавить: скобки, точку,
 * внутреннее имя поля. Чипом такой плейсхолдер становился только после
 * сохранения и повторного открытия формы — то есть ровно тогда, когда его уже
 * не правят.
 */
export class InsertPlaceholderChipCommand extends Command {
  public override execute({ token }: { token: string }): void {
    const model = this.editor.model;

    model.change((writer) => {
      const chip = writer.createElement(PLACEHOLDER_CHIP_MODEL, { token });

      model.insertObject(chip, undefined, undefined, {
        setSelection: "after",
      });
    });
  }

  /**
   * Команда доступна, пока в документе вообще есть куда писать.
   *
   * Сперва доступность считалась по месту курсора — и кнопки плейсхолдеров
   * молча переставали работать, когда курсора в редакторе не было: сразу после
   * загрузки формы и после переключения между обычным редактором и исходным
   * кодом. Нажатие не давало ни вставки, ни ошибки.
   *
   * Куда именно встанет предмет, решает `insertObject`: он сам найдёт
   * подходящее место, если выделение стоит там, где инлайновому предмету не
   * место.
   */
  public override refresh(): void {
    const root = this.editor.model.document.getRoot();

    this.isEnabled = root !== null;
  }
}
